module.exports = __webpack_public_path__ + "img/MANAVIS_thanks.f7587b32.jpg";